import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonButtonRowWidget, CommonSelectFieldWidget } from "@eforall/common";
import { FuncService } from "../../../../../services";
import { ChangeLanguageFormService } from "./change-language-form.service";

@Component({
	selector: 'acc-application-change-language-part',
	standalone: true,
	imports: [
		CommonSelectFieldWidget,
		CommonButtonRowWidget,
		FormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './change-language.part.html'
})
export class ChangeLanguagePart implements AfterViewInit {
	public readonly form = new ChangeLanguageFormService();
	private readonly func = inject(FuncService);
	public saveButton = viewChild.required<ElementRef<HTMLButtonElement>>('languageSaveBtn');

	ngAfterViewInit() {
		this.form.form.setSubmitButton(
			this.saveButton(),
			async (values, changed: string[]) => {
				const languageId = values.languageId;
				const accApplicationId = this.form.accAppDialogDataService.dialogData()?.details.accApplicationId;

				if (accApplicationId && !this.form.disableSaveBtn()) {
					try {
						await this.func.accApplication.updateLanguage({
							accApplicationId,
							languageId
						});

						// Reload the dialog data to reflect the change
						await this.form.accAppDialogDataService.reloadData();
					} catch (error) {
						console.error('Failed to update application language:', error);
					}
				}
			}
		)
	}
}
